import U from './../lib-utils'
import layerLayout from './layerLayout'

/**
 * Конструктор для создания слоев
 */
function abstract_layer() {
  throw new Error('-lib-map:abstract layer is abstract')
}

var P = U.fixup_constructor(abstract_layer).prototype

P.layout = null
P.handle = null
P.instance_id = null

/**
 * - Инициализирует слой с заданным макетом (layout). Проверяет корректность макета через layerLayout.is(layout).
 * - Генерирует уникальный instance_id для слоя
 */
P.init = function (layout) {
  if (!layerLayout.is(layout)) {
    throw new Error('-lib-map:abstractLayer designed to operate in layerLayout')
  }
  this.instance_id = ['layer', U.get_uuid().replace(/-/g, '')].join('')
  this.layout = layout
  this.init_binders()
  this.on_init.apply(this, Array.prototype.slice.call(arguments))
  return this
}

/**
 * "хук" для дополнительной инициализации в подклассах
 */
P.on_init = function () {}

/**
 * Создает привязки (bind) для методов получения размеров изображения и макета
 */
P.init_binders = function () {
  this.get_image_width = this._get_image_width.bind_to(this)
  this.get_image_height = this._get_image_height.bind_to(this)
  this.get_layout_width = this._get_layout_width.bind_to(this)
  this.get_layout_height = this._get_layout_height.bind_to(this)
}

/**
 * вызывается при готовности данных
 */
P.on_data_ready = function () {
  //
}

/**
 * вызывается при загрузке изображения
 */
P.on_image_ready = function () {
  //
}

/**
 * вызывается при наведении курсора
 */
P.on_hover = function () {
  //
}

/**
 * вызывается при клике/тапе, возвращает false, возможно, чтобы предотвратить стандартное поведение
 */
P.on_click_tap = function () {
  //
  return false
}

P.resize = function () {}

P.clear = function () {}

P.draw = function () {}

/**
 * Добавляет элемент element в начало тега <head>.
 * @param {HTMLElement} element
 * @returns {abstract_layer}
 */
P.prepend_node_to_head = function (element) {
  var heads = document.getElementsByTagName('head')
  if (!heads || !heads.length) {
    heads = document.getElementsByTagName('body')
    if (!heads || !heads.length) {
      heads = [document.documentElement]
    }
  }
  if (heads && heads.length) {
    if (heads[0].children.length) {
      heads[0].insertBefore(element, heads[0].children[0])
    } else {
      heads[0].appendChild(element)
    }
  }
  return this
}
/**
 * Добавляет элемент element в конец тега <head> (или <body>, если <head> отсутствует).
 * @param {HTMLElement} element
 * @returns {abstract_layer}
 */
P.append_node_to_head = function (element) {
  var heads = document.getElementsByTagName('head')
  if (!heads || !heads.length) {
    heads = document.getElementsByTagName('body')
    if (!heads || !heads.length) {
      heads = [document.documentElement]
    }
  }
  if (heads && heads.length) {
    heads[0].appendChild(element)
  }
  return this
}

/**
 * возвращают ширину фонового изображения
 * @returns {Number}
 */
P._get_image_width = function () {
  try {
    return this.get_background_image().width
  } catch (e) {
    //console.log(e);
  }
  return 0
}
/**
 * возвращают высоту фонового изображения
 * @returns {Number}
 */
P._get_image_height = function () {
  try {
    return this.get_background_image().height
  } catch (e) {
    //console.log(e);
  }
  return 0
}

/**
 * возвращают ширину изображения с учетом текущего масштаба (scale).
 * @returns {Number}
 */
P.get_scaled_image_width = function () {
  return this.layout.scale * this.get_image_width()
}
/**
 * возвращают высоту изображения с учетом текущего масштаба (scale).
 * @returns {Number}
 */
P.get_scaled_image_height = function () {
  return this.layout.scale * this.get_image_height()
}

/**
 * рассчитывают смещение изображения в пикселях по x
 * @returns {Number}
 */
P.get_pixel_image_offset_x = function () {
  return (
    this.layout.calculation_result.draw.x -
    this.layout.calculation_result.image.offset_x * this.layout.scale
  )
}
/**
 * рассчитывают смещение изображения в пикселях по y
 * @returns {Number}
 */
P.get_pixel_image_offset_y = function () {
  return (
    this.layout.calculation_result.draw.y -
    this.layout.calculation_result.image.offset_y * this.layout.scale
  )
}

/**
 * возвращают высоту макета
 * @returns {Number}
 */
P._get_layout_height = function () {
  return this.layout.layout_height
}

/**
 * возвращают ширину макета
 * @returns {Number}
 */
P._get_layout_width = function () {
  return this.layout.layout_width
}

/**
 * возвращает объект centralData из layout
 * @returns {Object}
 */
P.get_central_data = function () {
  return this.layout.centralData
}

/**
 * возвращает текущий вид отображения
 * @returns {Object}
 */
P.get_display_view = function () {
  return this.get_central_data().display_view
}

/**
 * возвращает текущее фоновое изображение
 * @returns {HTMLImageElement}
 */
P.get_background_image = function () {
  return this.get_central_data().image_canvas
}

/**
 * возвращает текущий масштаб
 * @returns {Number}
 */
P.get_scale = function () {
  return this.layout.scale
}

/**
 * нормализует число до 10 знаков после запятой
 */
P.norm_float = function (x) {
  return x.toFixed(10)
}

/**
 * пустой метод, вероятно, для проверки состояния подсветки элементов.
 */
P.check_hilight_state = function () {}

export default abstract_layer
